import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const DesignedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fill="currentColor"
        d="M2.7002,22.9999V.9999h9.6002v6.0001h5.5999v4.6121c.3437.0642.6766.1565,1,.2703v-6.2101L13.4949,0H1.7002v23.9999h11.2904c-.446-.2859-.8564-.6208-1.223-1H2.7002ZM13.3004,1.2453l4.5308,4.7548h-4.5308V1.2453Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M16.2999,10.6226c0-.2764-.2236-.5-.5-.5H4.8004c-.2764,0-.5.2236-.5.5s.2236.5.5.5h10.9995c.2764,0,.5-.2236.5-.5Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M11.6431,13.7037h-6.8427c-.2764,0-.5.2236-.5.5s.2236.5.5.5h6.0836c.2224-.3572.4763-.6912.7591-1Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M4.8004,17.2847c-.2764,0-.5.2236-.5.5s.2236.5.5.5h2.75c.2764,0,.5-.2236.5-.5s-.2236-.5-.5-.5h-2.75Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M18.2579,16.5279l-2.3154,2.3164-1.0469-.8877c-.209-.1768-.5254-.1514-.7051.0586-.1777.2109-.1523.5264.0586.7051l1.75,1.4814,2.9658-2.9668c.1953-.1953.1953-.5117,0-.707s-.5117-.1953-.707,0Z"
        className="primary"
      />
    </g>
    <path
      fill="currentColor"
      d="M16.5919,12.5836c-3.1475,0-5.708,2.5605-5.708,5.708s2.5605,5.708,5.708,5.708,5.708-2.5605,5.708-5.708-2.5605-5.708-5.708-5.708ZM16.5919,22.9996c-2.5957,0-4.708-2.1123-4.708-4.708s2.1123-4.708,4.708-4.708,4.708,2.1123,4.708,4.708-2.1123,4.708-4.708,4.708Z"
      className="accent"
    />
  </svg>
);

export default withCustomIcon(DesignedIcon);